import React, { useLayoutEffect, useRef, useState } from 'react'
import styles from './index.module.less'
import { useTranslation } from '@sailor/i18n-web'
import Container from '../Container'
import { Icon } from '@roo/roo'
import { useQuestionData } from './consts'
import { getDangerHtmlText } from '@/common/utils'


const QuestionDescription = () => {
  const { t } = useTranslation()
  const comRef = useRef(null)
  const questionData = useQuestionData()

  useLayoutEffect(() => {
    if (comRef.current) {
      setTimeout(() => {
        comRef.current.scrollIntoView({ behavior: 'smooth' })
      }, 100)
    }
  }, [])

  return (
    <div ref={comRef}>
      <Container gray>
        <div style={{ width: '100%' }} className={styles.pageWraper} >
          <div className={'section-title'} style={{ width: '100%', textAlign: 'center', paddingBottom: '3.8rem' }}>{t('ent_o_nav_faq', '常见问题')}</div>
          <div>
            {questionData.map((question) => (
              <div>
                <div className={styles.questionWraperTitle}>{question.title}</div>
                {
                  question.subQuestions.map((subQuestion) => (
                    <QuestionDescriptionCard title={subQuestion.title} content={subQuestion.anser} />
                  ))
                }
              </div>
            ))}
          </div>
        </div>
      </Container>
    </div>
  )
}

interface QuestionDescriptionCardProps {
  title: string;
  content: string;
}

const QuestionDescriptionCard: React.FC<QuestionDescriptionCardProps> = ({ title, content }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const toggleExpand = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <div className={styles.questionContainer}>
      <div className={styles.questionHeader} onClick={toggleExpand}>
        <h3 className={styles.questionTitle}>{title}</h3>
        <Icon name="chevron-up" className={`${styles.arrow} ${isExpanded ? styles.expanded : ''}`} />
      </div>
      <div className={`${styles.questionContent} ${isExpanded ? styles.expanded : ''}`}>
        <div style={{ paddingBottom: '3.2rem' }}  dangerouslySetInnerHTML={getDangerHtmlText(content)} />
      </div>
    </div>
  )
}
export default QuestionDescription
